// extracted by mini-css-extract-plugin
module.exports = {"list":"listdatakirim_list__2GLZp","gambar":"listdatakirim_gambar__205xT","rowMargin":"listdatakirim_rowMargin__3H3av","garisBawah":"listdatakirim_garisBawah__q4wmm"};